import { Navigate } from 'react-router-dom'
import EmailIcon from '@mui/icons-material/Email'
import ChatIcon from '@mui/icons-material/Chat'
import LowPriorityIcon from '@mui/icons-material/LowPriority'

import SettingsPage from '../components/pages/SettingsPage'
import SettingsTemplatesPage from '../components/pages/SettingsTemplatesPage'
import SettingsTemplateLettersPage from '../components/pages/SettingsTemplateLettersPage'
import SettingsTemplateCommunicationsPage from '../components/pages/SettingsTemplateCommunicationsPage'
import SettingsFilesPage from '../components/pages/SettingsFilesPage'
import SettingsFileOrderingPage from '../components/pages/SettingsFileOrderingPage'

export const allSettingsSections = {
  templates: {
    label: 'Templates',
    path: '/settings/templates',
    element: <SettingsTemplatesPage />,
    subsections: {
      letters: {
        label: 'Letters',
        description: 'View, edit, and delete your "Letters" templates.',
        icon: <EmailIcon />,
        path: '/settings/templates/letters',
        element: <SettingsTemplateLettersPage />
      },
      communications: {
        label: 'Communications',
        description: 'View, edit, and delete your "Communications" templates.',
        icon: <ChatIcon />,
        path: '/settings/templates/communications',
        element: <SettingsTemplateCommunicationsPage />
      }
    }
  },
  files: {
    label: 'Files',
    path: '/settings/files',
    element: <SettingsFilesPage />,
    subsections: {
      fileOrdering: {
        label: 'File Ordering',
        description: 'Choose which date sources decide the order of files in a category before combining.',
        icon: <LowPriorityIcon />,
        path: '/settings/files/file-ordering',
        element: <SettingsFileOrderingPage />
      }
    }
  }
}

const sections = Object.values(allSettingsSections)

export const settingsRoutes = {
  path: '/settings',
  element: <SettingsPage />,
  children: [
    { index: true, element: <Navigate replace to={sections[0].path} /> },
    ...sections.flatMap(({ path, element, subsections = {} }) => [
      { path, element },
      ...Object.values(subsections).map(sub => ({ path: sub.path, element: sub.element }))
    ])
  ]
}
